export type GuidanceMode = 'inline' | 'helper' | 'banner'
export type GuidanceState = 'safe' | 'warn' | 'at' | 'danger' | 'verified'

export const NOTICE_TYPE_TO_STATE: Record<string, GuidanceState> = {
  'alert-warning': 'warn',
  'alert-danger': 'danger',
  'alert-success': 'verified',
  'alert-info': 'safe',
}

export const STATE_CLASSES: Record<GuidanceState, { bg: string; text: string; border: string }> = {
  safe: {
    bg: 'bg-guidance-safe-bg',
    text: 'text-guidance-safe-text',
    border: 'border-guidance-safe-border',
  },
  warn: {
    bg: 'bg-guidance-warn-bg',
    text: 'text-guidance-warn-bannerText',
    border: 'border-guidance-warn-border',
  },
  at: {
    bg: 'bg-guidance-warn-bg',
    text: 'text-guidance-warn-bannerText',
    border: 'border-guidance-warn-border',
  },
  danger: {
    bg: 'bg-guidance-danger-bg',
    text: 'text-guidance-danger-text',
    border: 'border-guidance-danger-border',
  },
  verified: {
    bg: 'bg-guidance-verified-bg',
    text: 'text-guidance-verified',
    border: 'border-guidance-verified-border',
  },
}

export const STATE_ICONS: Record<GuidanceState, [string, string]> = {
  verified: ['fas', 'circle-check'],
  safe: ['fas', 'circle-info'],
  warn: ['fas', 'triangle-exclamation'],
  at: ['fas', 'triangle-exclamation'],
  danger: ['fas', 'circle-xmark'],
}

export const WARN_BORDER_COLORS: Record<GuidanceState, string> = {
  safe: 'border-guidance-safe-border',
  warn: 'border-guidance-warn-accent',
  at: 'border-guidance-warn-accent',
  danger: 'border-guidance-danger-border',
  verified: 'border-guidance-verified',
}
